const translations = {
  "en": {
    "Access code not bind": "Access code not bind",
    "Authentication failed": "Authentication failed",
    "Chat is already in progress": "Chat is already in progress",
    "Chat not found": "Chat not found",
    "Deepsearch limit reached, switched to standard responses.": "Deepsearch limit reached, switched to standard responses.",
    "File type is not supported": "File type is not supported",
    "File upload failed": "File upload failed",
    "Guest ID is invalid or missing": "Guest ID is invalid or missing",
    "Internal server error": "Internal server error",
    "Invalid chat ID": "Invalid chat ID",
    "Invalid Message": "Invalid Message",
    "Invalid parameters": "Invalid parameters",
    "Invalid token": "Invalid token",
    "Message not found": "Message not found",
    "Ser, slow down. AI needs oxygen, and you need to touch grass.": "Ser, slow down. AI needs oxygen, and you need to touch grass.",
    "Share has expired": "Share has expired",
    "Share not found": "Share not found",
    "Something went wrong. Please try again.": "Something went wrong. Please try again.",
    "Unauthorized access": "Unauthorized access",
    "Your account has been flagged as a risky account. Please contact us via Discord to unblock it.": "Your account has been flagged as a risky account. Please contact us via Discord to unblock it."
  },
  "zh-tw": {
    "Access code not bind": "未綁定存取碼",
    "Authentication failed": "驗證失敗",
    "Chat is already in progress": "已有對話正在進行",
    "Chat not found": "未找到該對話",
    "Deepsearch limit reached, switched to standard responses.": "Deep Search 額度已達上限，已切換至標準回覆。",
    "File type is not supported": "不支援的檔案類型",
    "File upload failed": "檔案上傳失敗",
    "Guest ID is invalid or missing": "訪客 ID 無效或遺失",
    "Internal server error": "伺服器內部錯誤",
    "Invalid chat ID": "無效的對話 ID",
    "Invalid Message": "無效訊息",
    "Invalid parameters": "無效參數",
    "Invalid token": "Token 無效",
    "Message not found": "未找到該訊息",
    "Ser, slow down. AI needs oxygen, and you need to touch grass.": "稍等一下，AI 需要喘口氣，你也該出去走走了。",
    "Share has expired": "分享連結已過期",
    "Share not found": "未找到該分享",
    "Something went wrong. Please try again.": "發生錯誤。請再試一次。",
    "Unauthorized access": "無存取權限",
    "Your account has been flagged as a risky account. Please contact us via Discord to unblock it.": "你的帳號已被標記為風險帳號。請透過 Discord 聯繫我們以進行解鎖。"
  }
};

export default translations;
